import delve from 'dlv';

/** Helper to check wether an element is or is the child of a parent with a specific data-attribute */
export default (child: any, parentDataAttribute: any): any => {
  if (delve(child, `dataset.${parentDataAttribute}`)) return true;

  let node = child.parentNode;

  while (node !== null) {
    if (delve(node, `dataset.${parentDataAttribute}`)) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};
